import Api from "./api.service";

class Wti {
  static updateKeys() {
    return Api.get("/api/v1/update_wti_keys/");
  }

  static fetchTranslations() {
    const payload = {};
    return Api.get("/api/v1/fetch_wti_translations/");
  }
}

const WtiService = Object.freeze(Wti);
export default WtiService;
